import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

// Swiper core styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const InventoryDetailSection = ({data,loading,error,handleClose}) => {
  const chunkArray = (arr, chunkSize) => {
  const chunks = [];
  const perColumn = Math.ceil(arr.length / chunkSize);

  for (let i = 0; i < chunkSize; i++) {
    chunks.push(arr.slice(i * perColumn, (i + 1) * perColumn));
  }
  return chunks;
};
const columns = data?.features?.features ? chunkArray(data?.features?.features, 4) : null

const message = encodeURIComponent(
  "Hello! I am interested in this car. Please share more details.\n\n" +
  `Car Title: ${data?.title}\n` +
  `Model: ${data?.carDetails?.model} (${data?.carDetails?.year})\n` +
  `Company: ${data?.carDetails?.company}\n` +
  `Fuel Type: ${data?.carDetails?.fuelType}\n` +
  `Transmission: ${data?.carDetails?.transmission}\n` +
  `Mileage: ${data?.carDetails?.mileage} km\n` +
  `Engine Size: ${data?.carDetails?.engineSize}\n` +
  `Color: ${data?.carDetails?.color}\n` +
  `Doors: ${data?.carDetails?.door}\n\n` +
  `Features: ${data?.features?.features?.join(", ")}\n\n` +
  `Price: ₹${data?.price?.amount}\n\n` +
  "Thank you!"
);
  return (
    <div>
      <section style={{paddingBottom:"100px", zIndex:9999}} className="inventory-section layout-radius">
        {error && <div className="p-5"><p style={{fontSize:"18px",color:"red"}}>{error}</p></div>}
        {loading ? <div className="p-5"><p className="text-center">Loading...</p></div>:<div className="boxcar-container pt-5">
          <div className="boxcar-title-three">
            <h2><i className="fa fa-arrow-left" style={{fontSize:"30px",cursor:"pointer"}} onClick={handleClose}></i> {data?.title}</h2>
            <div className="text">
            </div>
            <ul className="spectes-list">
              {data?.carDetails?.year && <li>
                <span>
                  <img src="images/resource/spec1-1.svg" />
                  {data?.carDetails?.year}
                </span>
              </li>}
              {data?.carDetails?.mileage && <li>
                <span>
                  <img src="images/resource/spec1-2.svg" />
                  {data?.carDetails?.mileage } mileage
                </span>
              </li>}
              {data?.carDetails?.transmission && <li>
                <span>
                  <img src="images/resource/spec1-3.svg" />
                  {data?.carDetails?.transmission}
                </span>
              </li>}
              {data?.carDetails?.fuelType && <li>
                <span>
                  <img src="images/resource/spec1-4.svg" />
                  {data?.carDetails?.fuelType}
                </span>
              </li>}
            </ul>
            <div className="content-box">
              {data?.price?.priceWithTax && <h3 className="title">${data?.price?.priceWithTax}</h3>}
              <span>
                <svg
                  width={18}
                  height={18}
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_163_10380)">
                    <path
                      d="M7.8047 17.4287C7.80429 17.4287 7.80378 17.4287 7.80326 17.4287C7.2752 17.4283 6.77865 17.2223 6.40539 16.8484L1.14802 11.5835C0.379045 10.8131 0.379045 9.55955 1.14802 8.78923L8.23503 1.68863C8.96538 0.956841 9.93715 0.553711 10.9712 0.553711H15.4676C16.5579 0.553711 17.4451 1.44072 17.4451 2.53125V7.01377C17.4451 8.04714 17.0424 9.01851 16.3113 9.74875L9.20227 16.8504C8.8288 17.2233 8.33246 17.4287 7.8047 17.4287ZM10.9712 1.87207C10.2898 1.87207 9.64948 2.1377 9.16818 2.61993L2.08107 9.72053C1.82471 9.97741 1.82471 10.3952 2.08107 10.652L7.33844 15.9169C7.46276 16.0414 7.62817 16.1102 7.80429 16.1104H7.80481C7.98073 16.1104 8.14614 16.0419 8.27056 15.9176L15.3796 8.81612C15.8614 8.33492 16.1267 7.69469 16.1267 7.01377V2.53125C16.1267 2.16777 15.831 1.87207 15.4676 1.87207H10.9712ZM12.6659 7.24438C11.5755 7.24438 10.6884 6.35738 10.6884 5.26685C10.6884 4.17632 11.5755 3.28931 12.6659 3.28931C13.7564 3.28931 14.6435 4.17632 14.6435 5.26685C14.6435 6.35738 13.7564 7.24438 12.6659 7.24438ZM12.6659 4.60767C12.3025 4.60767 12.0068 4.90337 12.0068 5.26685C12.0068 5.63032 12.3025 5.92603 12.6659 5.92603C13.0295 5.92603 13.3251 5.63032 13.3251 5.26685C13.3251 4.90337 13.0295 4.60767 12.6659 4.60767Z"
                      fill="#050B20"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_163_10380">
                      <rect width={18} height={18} fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                {data?.isActive?"Active":"In-Active"}
              </span>
            </div>
          </div>
          <div className="gallery-sec">
            {data?.media && data?.media?.length > 0 && <div className="row">
            { data?.media?.length === 1  ?<>
                                      <div className="image-column item1 col-lg-12 col-md-12 col-sm-12">
                          <div className="inner-column">
                            <div className="image-box">
                              <Swiper
                                modules={[Navigation, Autoplay]}
                                navigation={{
                                  prevEl: ".custom-prev",
                                  nextEl: ".custom-next",
                                }}
                                className="image"
                              >
                                  <SwiperSlide >
          
                                  <a href={data?.media[0]?.path} data-fancybox="gallery">
                                  <img src={data?.media[0]?.path}   />
                                </a>
                                </SwiperSlide>
                              </Swiper>
                               <button style={{position:"absolute" , top:"40%", color:"black", border:"1px solid white", backgroundColor:"#f3f3f3", opacity:"0.8" }} className="swiper-prevv custom-prev slick-arrow" aria-label="Previous">
                                            <FaChevronLeft size={18} />
                                          </button>
                                          <button style={{position:"absolute" , top:"40%", color:"black", border:"1px solid white", backgroundColor:"#f3f3f3", opacity:"0.8" }} className="swiper-nextt custom-next slick-arrow" aria-label="Next">
                                            <FaChevronRight size={18} />
                                          </button>
                              {/* <figure className="image">
                              
                              </figure> */}
                            </div>
                          </div>
                        </div>
                        </> : <>
                                      <div className="image-column item1 col-lg-5 col-md-12 col-sm-12">
                          <div className="inner-column">
                            <div className="image-box">
                              <Swiper
                                modules={[Navigation, Autoplay]}
                                navigation={{
                                  prevEl: ".custom-prev",
                                  nextEl: ".custom-next",
                                }}
                                className="image"
                              >
          
                                {
                                  data?.media?.map((media,index)=><SwiperSlide key={index} >
          
                                   <a href={media?.path} data-fancybox="gallery">
                                  <img src={media?.path}   />
                                </a>
                                  </SwiperSlide>)
                                }
                              </Swiper>
                               <button style={{position:"absolute" , top:"40%", color:"black", border:"1px solid white", backgroundColor:"#f3f3f3", opacity:"0.8" }} className="swiper-prevv custom-prev slick-arrow" aria-label="Previous">
                                            <FaChevronLeft size={18} />
                                          </button>
                                          <button style={{position:"absolute" , top:"40%", color:"black", border:"1px solid white", backgroundColor:"#f3f3f3", opacity:"0.8" }} className="swiper-nextt custom-next slick-arrow" aria-label="Next">
                                            <FaChevronRight size={18} />
                                          </button>
                              {/* <figure className="image">
                              
                              </figure> */}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-7 col-md-12 col-sm-12">
                          <div className="row">
                            {data?.media[1] && <div className="image-column-two item2 col-6" style={{height:"200px",width:"230px"}}>
                              <div className="inner-column">
                                <div className="image-box">
                                  <figure className="image">
                                    <a
                                      href={data?.media[1]?.path}
                                      data-fancybox="gallery"
                                      className="fancybox"
                                    >
                                      <img style={{height:"200px",width:"230px"}} src={data?.media[1]?.path}  />
                                    </a>
                                  </figure>
                                </div>
                              </div>
                            </div>}
                            {data?.media[2] && <div className="image-column-two item3 col-6" style={{height:"200px",width:"230px"}}>
                              <div className="inner-column">
                                <div className="image-box">
                                  <figure className="image">
                                    <a
                                      href={data?.media[2]?.path}
                                      data-fancybox="gallery"
                                    >
                                      <img style={{height:"200px",width:"230px"}} src={data?.media[2]?.path}   />
                                    </a>
                                  </figure>
                                </div>
                              </div>
                            </div>}
                            {data?.media[3] && <div className="image-column-two item4 col-6" style={{height:"200px",width:"230px"}}>
                              <div className="inner-column">
                                <div className="image-box">
                                  <figure className="image">
                                    <a
                                      href={data?.media[3]?.path}
                                      data-fancybox="gallery"
                                    >
                                      <img style={{height:"200px",width:"230px"}} src={data?.media[3]?.path}   />
                                    </a>
                                  </figure>
                                </div>
                              </div>
                            </div>}
                            {data?.media[4] && <div className="image-column-two item5 col-6" style={{height:"200px",width:"230px"}}>
                              <div className="inner-column">
                                <div className="image-box">
                                  <figure className="image">
                                    <a
                                      href={data?.media[4]?.path}
                                      data-fancybox="gallery"
                                    >
                                      <img style={{height:"200px",width:"230px"}} src={data?.media[4]?.path}/>
                                    </a>
                                  </figure>
                                </div>
                              </div>
                            </div>}
                          </div>
                        </div>
                        </> }
            </div>}
          </div>
          <div className="row">
            <div className="inspection-column col-lg-8 col-md-12 col-sm-12">
              <div className="inner-column">
                {/* overview-sec */}
                <div className="overview-sec">
                  <h4 className="title">Car Overview</h4>
                  <div className="row">
                    <div className="content-column col-lg-6 col-md-12 col-sm-12">
                      <div className="inner-column">
                        <ul className="list">
                          <li>
                            <span>
                              <img src="images/resource/insep1-1.svg" />
                              Model
                            </span>
                            {data?.carDetails?.model}
                          </li>
                          <li>
                            <span>
                              <img src="images/resource/insep1-2.svg" />
                              Mileage
                            </span>
                            {data?.carDetails?.mileage} miles
                          </li>
                          <li>
                            <span>
                              <img src="images/resource/insep1-3.svg" />
                              Fuel Type
                            </span>
                            {data?.carDetails?.fuelType}
                          </li>
                          <li>
                            <span>
                              <img src="images/resource/insep1-4.svg" />
                              Year
                            </span>
                            {data?.carDetails?.year}
                          </li>
                          <li>
                            <span>
                              <img src="images/resource/insep1-5.svg" />
                              Transmission
                            </span>
                            {data?.carDetails?.transmission}
                          </li>
                          <li>
                            <span>
                              <img src="images/resource/insep1-6.svg" />
                              Company
                            </span>
                            {data?.carDetails?.company}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="content-column col-lg-6 col-md-12 col-sm-12">
                      <div className="inner-column">
                        <ul className="list">
                          <li>
                            <span>
                              <img src="images/resource/insep1-7.svg" />
                              Condition
                            </span>
                            Used
                          </li>
                          <li>
                            <span>
                              <img src="images/resource/insep1-8.svg" />
                              Engine Size
                            </span>
                            {data?.carDetails?.engineSize}
                          </li>
                          <li>
                            <span>
                              <img src="images/resource/insep1-9.svg" />
                              Doors
                            </span>
                            {data?.carDetails?.door}-door
                          </li>
                          <li>
                            <span>
                              <img src="images/resource/insep1-10.svg" />
                              Tax
                            </span>
                            {data?.price?.taxPercentage}%
                          </li>
                          <li>
                            <span>
                              <img src="images/resource/insep1-11.svg" />
                              Color
                            </span>
                            {data?.carDetails?.color}
                          </li>
                          {/* <li>
                            <span>
                              <img src="images/resource/insep1-12.svg" />
                              VIN
                            </span>
                            ZN682AVA2P7429564
                          </li> */}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/* description-sec */}
                {data?.carDetails?.description && <div className="description-sec">
                  <h4 className="title">Description</h4>
                  <div className="text">{data?.carDetails?.description}</div>
                  {/* <ul className="des-list">
                    <li>
                      <a href="#" className="item">
                        <img src="images/resource/book1-1.svg" />
                        View Vin Report
                      </a>
                    </li>
                    <li className="two">
                      <a href="#" className="item">
                        <img src="images/resource/book1-2.svg" />
                        Car Brochure
                      </a>
                    </li>
                    <li className="three">
                      <a href="#" className="item">
                        <img src="images/resource/book1-3.svg" />
                        Schedule Test Drive
                      </a>
                    </li>
                  </ul> */}
                </div>}
                {/* features-sec */}
                <div className="features-sec">
                  <h4 className="title">Features</h4>
                  <div className="row">
                    {columns?.map((features,index)=>{
                      return (<div key={index} className="list-column col-lg-3 col-md-6 col-sm-12">
                        <div className="inner-column">
                        <ul className="feature-list">
                          {features?.map((f,i)=><li key={i}>
                            <i className="fa-solid fa-check" />
                            {f}
                          </li>)}
                        </ul>
                      </div>
                    </div>)
                    })}
                  </div>
                </div>
              </div>
            </div>
             <div className="side-bar-column style-1 col-lg-4 col-md-12 col-sm-12">
              <div className="inner-column">
                <div className="contact-box">
                  <div className="icon-box" style={{backgroundColor:"black"}}> 
                    <img src="images/logo.png" />
                  </div>
                  <div className="content-box">
                    <h6 className="title">Car Junction</h6>
                    <div className="text">
                      205 King St W #2 Oshawa, ON L1J 4C1, Canada.
                    </div>
                    <ul className="contact-list">
                      <li>
                        <a target="_blank" href="https://share.google/kSiTv6K4DenRMND8B">
                          <div className="image-box">
                            <img src="images/resource/phone1-1.svg" />
                          </div>
                          Get Directions
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <div className="image-box">
                            <img src="images/resource/phone1-2.svg" />
                          </div>
                          +1 416-5626-307
                        </a>
                      </li>
                    </ul>
                    <div className="btn-box">
                      <a target="_blank" href={`https://wa.me/14165626307?text=${message?message:""}`} className="side-btn two">
                        Chat Via Whatsapp
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={14}
                          height={14}
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_881_8744)">
                            <path
                              d="M13.6111 0H5.05558C4.84062 0 4.66668 0.173943 4.66668 0.388901C4.66668 0.603859 4.84062 0.777802 5.05558 0.777802H12.6723L0.113941 13.3362C-0.0379805 13.4881 -0.0379805 13.7342 0.113941 13.8861C0.189884 13.962 0.289415 14 0.38891 14C0.488405 14 0.5879 13.962 0.663879 13.8861L13.2222 1.3277V8.94447C13.2222 9.15943 13.3962 9.33337 13.6111 9.33337C13.8261 9.33337 14 9.15943 14 8.94447V0.388901C14 0.173943 13.8261 0 13.6111 0Z"
                              fill="#60C961"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_881_8744">
                              <rect width={14} height={14} fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
      </section>
    </div>
  );
};

export default InventoryDetailSection;
